// src/pages/step/STEPPlans.jsx
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Plus, Pencil, Ban, CheckCircle2, X } from "lucide-react";
import { stepPlansAPI } from "../../services/stepService";

export default function STEPPlans() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    plan_type: "MONTHLY",
    price: "",
    duration_days: "",
    description: "",
    is_active: true,
  });

  const loadPlans = async () => {
    setLoading(true);
    setError("");
    try {
      const data = await stepPlansAPI.getAllAdmin();
      setPlans(data.plans || []);
    } catch (err) {
      setError(err?.response?.data?.error || "تعذر تحميل الخطط");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPlans();
  }, []);

  const resetForm = () => {
    setForm({
      plan_type: "MONTHLY",
      price: "",
      duration_days: "",
      description: "",
      is_active: true,
    });
    setEditingId(null);
    setShowForm(false);
  };

  const startEdit = (plan) => {
    setForm({
      plan_type: plan.plan_type,
      price: plan.price,
      duration_days: plan.duration_days,
      description: plan.description || "",
      is_active: plan.is_active,
    });
    setEditingId(plan.id);
    setShowForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");
    try {
      if (editingId) {
        await stepPlansAPI.update(editingId, {
          price: form.price,
          duration_days: form.duration_days,
          description: form.description,
          is_active: form.is_active,
        });
      } else {
        await stepPlansAPI.create({
          plan_type: form.plan_type,
          price: form.price,
          duration_days: form.duration_days,
          description: form.description,
          is_active: form.is_active,
        });
      }
      resetForm();
      await loadPlans();
    } catch (err) {
      setError(err?.response?.data?.error || "حدث خطأ أثناء الحفظ");
    } finally {
      setSaving(false);
    }
  };

  const handleToggleActive = async (plan) => {
    setError("");
    try {
      if (plan.is_active) {
        await stepPlansAPI.delete(plan.id); // تعطيل، مش حذف فعلي
      } else {
        await stepPlansAPI.update(plan.id, { is_active: true });
      }
      await loadPlans();
    } catch (err) {
      setError(err?.response?.data?.error || "تعذر تحديث حالة الخطة");
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div>
          <Link
            to="/dashboard/step"
            style={{ fontSize: 13, color: "var(--text-secondary)", textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 4 }}
          >
            <ArrowRight size={14} /> رجوع لـ STEP
          </Link>
          <h1 style={{ fontSize: 22, fontWeight: 700, marginTop: 8 }}>خطط اشتراك STEP</h1>
        </div>
        <button
          onClick={() => (showForm ? resetForm() : setShowForm(true))}
          className="step-card"
          style={{ padding: "10px 16px", display: "flex", alignItems: "center", gap: 8, cursor: "pointer", border: "none" }}
        >
          {showForm ? <X size={16} /> : <Plus size={16} />}
          {showForm ? "إلغاء" : "إضافة خطة"}
        </button>
      </div>

      {error && (
        <div style={{ padding: 12, borderRadius: 12, background: "rgba(244,63,94,0.10)", color: "#f43f5e", fontSize: 13 }}>
          {error}
        </div>
      )}

      {showForm && (
        <form onSubmit={handleSubmit} className="step-card" style={{ display: "grid", gap: 14 }}>
          {!editingId && (
            <div>
              <label style={{ fontSize: 12, fontWeight: 600 }}>نوع الخطة</label>
              <select
                value={form.plan_type}
                onChange={(e) => setForm({ ...form, plan_type: e.target.value })}
                style={{ width: "100%", padding: 10, borderRadius: 10, marginTop: 6 }}
              >
                <option value="MONTHLY">شهر واحد</option>
                <option value="QUARTERLY">ثلاثة أشهر</option>
              </select>
            </div>
          )}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
            <div>
              <label style={{ fontSize: 12, fontWeight: 600 }}>السعر (ريال)</label>
              <input
                type="number"
                step="0.01"
                required
                value={form.price}
                onChange={(e) => setForm({ ...form, price: e.target.value })}
                style={{ width: "100%", padding: 10, borderRadius: 10, marginTop: 6 }}
              />
            </div>
            <div>
              <label style={{ fontSize: 12, fontWeight: 600 }}>مدة الاشتراك (أيام)</label>
              <input
                type="number"
                required
                value={form.duration_days}
                onChange={(e) => setForm({ ...form, duration_days: e.target.value })}
                style={{ width: "100%", padding: 10, borderRadius: 10, marginTop: 6 }}
              />
            </div>
          </div>
          <div>
            <label style={{ fontSize: 12, fontWeight: 600 }}>الوصف</label>
            <input
              type="text"
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
              style={{ width: "100%", padding: 10, borderRadius: 10, marginTop: 6 }}
            />
          </div>
          <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13 }}>
            <input
              type="checkbox"
              checked={form.is_active}
              onChange={(e) => setForm({ ...form, is_active: e.target.checked })}
            />
            الخطة نشطة (تظهر للطلاب)
          </label>
          <button
            type="submit"
            disabled={saving}
            style={{ padding: "10px 16px", borderRadius: 10, border: "none", background: "#2563eb", color: "#fff", fontWeight: 600, cursor: "pointer" }}
          >
            {saving ? "جارٍ الحفظ..." : editingId ? "حفظ التعديلات" : "إنشاء الخطة"}
          </button>
        </form>
      )}

      <div className="step-card">
        <div className="step-section-title">الخطط الحالية</div>
        {loading ? (
          <p style={{ fontSize: 13, color: "var(--text-secondary)" }}>جارٍ التحميل...</p>
        ) : plans.length === 0 ? (
          <p style={{ fontSize: 13, color: "var(--text-secondary)" }}>لا توجد خطط بعد</p>
        ) : (
          <div style={{ display: "grid", gap: 10 }}>
            {plans.map((plan) => (
              <div
                key={plan.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "14px 16px",
                  borderRadius: 14,
                  background: "var(--step-inner-bg)",
                  border: "1px solid var(--step-inner-border)",
                }}
              >
                <div>
                  <div style={{ fontWeight: 700, fontSize: 14, display: "flex", alignItems: "center", gap: 8 }}>
                    {plan.name}
                    <span
                      style={{
                        fontSize: 10,
                        padding: "2px 8px",
                        borderRadius: 99,
                        background: plan.is_active ? "rgba(34,197,94,0.15)" : "rgba(148,163,184,0.20)",
                        color: plan.is_active ? "#16a34a" : "#64748b",
                      }}
                    >
                      {plan.is_active ? "نشطة" : "معطّلة"}
                    </span>
                  </div>
                  <div style={{ fontSize: 12, color: "var(--text-secondary)", marginTop: 4 }}>
                    {plan.price} ريال · {plan.duration_days} يوم
                    {plan.description ? ` · ${plan.description}` : ""}
                  </div>
                </div>
                <div style={{ display: "flex", gap: 8 }}>
                  <button
                    onClick={() => startEdit(plan)}
                    style={{ padding: 8, borderRadius: 8, border: "none", background: "rgba(59,130,246,0.12)", cursor: "pointer" }}
                  >
                    <Pencil size={14} className="step-icon-blue" />
                  </button>
                  <button
                    onClick={() => handleToggleActive(plan)}
                    style={{
                      padding: 8,
                      borderRadius: 8,
                      border: "none",
                      background: plan.is_active ? "rgba(244,63,94,0.12)" : "rgba(34,197,94,0.12)",
                      cursor: "pointer",
                    }}
                  >
                    {plan.is_active ? <Ban size={14} className="step-icon-rose" /> : <CheckCircle2 size={14} className="step-icon-green" />}
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}